// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-close {\n  position: fixed;\n  cursor: pointer;\n  left: 15px;\n  top: 15px;\n  width: 32px;\n  height: 32px;\n  background: #ffffff;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 12px 24px rgba(26, 26, 26, 0.16);\n  justify-content: center;\n  z-index: 999;\n}\n.trace-model-wrap .map-control-button-container {\n  display: none;\n}\n.trace-model-wrap .mapbox-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
